import { useAtom } from "jotai"

import { deleteConfirmationAtom } from "../state"
import Modal from "./Modal"
import Button from "./Button"

const DeleteConfirmation = () => {
  const [deleteConfirmation, setDeleteConfirmation] = useAtom(deleteConfirmationAtom)

  return (
    <Modal
      width="md:max-w-xl"
      isOpen={deleteConfirmation !== null}
      setIsOpen={() => setDeleteConfirmation(null)}
    >
      <div className="text-center">
        <h1 className="text-brand-secondary mb-4 text-xl font-bold">
          Are you sure you want to delete this?
        </h1>
        <div className="flex flex-col items-center gap-4">
          <Button
            variant="default"
            onClick={() => {
              deleteConfirmation()
              setDeleteConfirmation(null)
            }}
          >
            Delete
          </Button>
          <Button
            variant="secondary-ghost"
            onClick={() => {
              setDeleteConfirmation(null)
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default DeleteConfirmation
